import { classNames } from "../../helpers";

type AppButtonProps = {
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
  cypressSelector?: string;
  buttonShape: "primary" | "primary-danger" | "secondary";
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
};
export default function AppButton(props: AppButtonProps) {
  const {
    children,
    onClick,
    className,
    cypressSelector,
    buttonShape,
    type = "button",
    disabled = false,
  } = props;
  const buttonClasses = classNames(
    "inline-flex items-center justify-center px-4 py-2 border text-sm font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2",
    buttonShape === "primary" &&
      "border-transparent bg-brandblue-600 text-white hover:bg-brandblue-700 disabled:bg-gray-400 focus:ring-brandblue-500",
    buttonShape === "secondary" &&
      "border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-brandblue-500",
    buttonShape === "primary-danger" &&
      "border-transparent bg-red-600 text-white hover:bg-red-700 disabled:opacity-80 disabled:hover:bg-red-600 focus:ring-red-500",
    className
  );
  return (
    <button
      type={type}
      data-cy={cypressSelector}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
